export * from './newsletter.variants.defaults';
